/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Admin_Company_Overview_Tenant_LogoInputs */

const es_admin_company_overview_tenant_logo = /** @type {(inputs: Admin_Company_Overview_Tenant_LogoInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Logo de la empresa`)
};

const en_admin_company_overview_tenant_logo = /** @type {(inputs: Admin_Company_Overview_Tenant_LogoInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Company Logo`)
};

/**
* | output |
* | --- |
* | "Company Logo" |
*
* @param {Admin_Company_Overview_Tenant_LogoInputs} inputs
* @param {{ locale?: "es" | "en" }} options
* @returns {LocalizedString}
*/
const admin_company_overview_tenant_logo = /** @type {((inputs?: Admin_Company_Overview_Tenant_LogoInputs, options?: { locale?: "es" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Admin_Company_Overview_Tenant_LogoInputs, { locale?: "es" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_admin_company_overview_tenant_logo(inputs)
	return en_admin_company_overview_tenant_logo(inputs)
});
export { admin_company_overview_tenant_logo as "admin.company_overview.tenant_logo" }